import { useState } from "react";

/**
 * Panneau dépliable avec :
 * - grille des pochettes alternatives (multi-sources)
 * - formulaire d'URL custom pour valider une image externe en Permanent
 */
function hideBrokenTile(e) {
  // Image cassée (404 CoverArtArchive surtout) : masque la vignette parente
  // pour ne pas afficher l'icône d'image cassée du browser.
  const tile = e.currentTarget.parentElement;
  if (tile) tile.style.display = "none";
}

function SuggestionsGrid({ suggestions, busy, onValidate }) {
  if (suggestions.length === 0) {
    return <div className="art-alt-empty">Aucune proposition trouvée.</div>;
  }
  return (
    <div className="art-alt-grid">
      {suggestions.map((s) => (
        <button
          key={s.artwork_url}
          type="button"
          className="art-alt-tile"
          onClick={() => onValidate(s.artwork_url, s.source, false)}
          disabled={busy}
          title={`${s.source} · valider`}
        >
          <img src={s.artwork_url} alt={s.source} onError={hideBrokenTile} />
          <span className="art-alt-src">{s.source}</span>
        </button>
      ))}
    </div>
  );
}

function CustomUrlForm({ busy, onSubmit }) {
  const [customUrl, setCustomUrl] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const trimmed = customUrl.trim();
    if (trimmed.startsWith("http")) {
      onSubmit(trimmed);
      setCustomUrl("");
    }
  };
  return (
    <form onSubmit={submit} className="art-alt-custom">
      <input
        type="url"
        placeholder="Coller une URL d'image…"
        value={customUrl}
        onChange={(e) => setCustomUrl(e.target.value)}
        className="mw-input"
      />
      <button
        type="submit"
        className="mw-btn mw-btn-ghost art-alt-custom-btn"
        disabled={busy}
      >
        Valider URL ⭐
      </button>
    </form>
  );
}

export function ArtworkAlternatives({ suggestions, busy, onValidate }) {
  return (
    <div className="art-alternatives">
      <SuggestionsGrid suggestions={suggestions} busy={busy} onValidate={onValidate} />
      <CustomUrlForm
        busy={busy}
        onSubmit={(url) => onValidate(url, "manual-url", true)}
      />
    </div>
  );
}
